import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-pinned-help',
  templateUrl: './pinned-help.component.html',
  styleUrl: './pinned-help.component.scss',
  standalone: false,
})
export class PinnedHelpComponent {
  constructor(private dialog: MatDialog) {}

  onCloseDialog(): void {
    this.dialog.closeAll();
  }
}
